import { useEffect, useState } from "react";

const PaymentCTA = () => {

  const [typeCta, setTypeCta] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const cta = params.get('cta');
    if (cta) {
      setTypeCta(cta);
    }
  }, []);


  return (
    <section id="pagamento" className="py-16 bg-gradient-to-br from-gray-900 to-gray-800 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-64 h-64 bg-[#E18E37] rounded-full filter blur-3xl"></div>
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-6">
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-2">
              NÃO PERCA ESSA OPORTUNIDADE 👇
            </h2>
          </div>

          <div className="bg-gradient-to-br from-[#E18E37] to-[#C67A2A] rounded-2xl shadow-2xl p-6 md:p-8">
            <div className="grid md:grid-cols-2 gap-6 items-center mb-6">
              {typeCta ?
                <>
                  <div className="text-center md:text-left">
                    <p className="text-gray-800 text-sm font-semibold mb-1">DE R$ 400,00 POR:</p>
                    <p className="text-4xl md:text-5xl font-black text-gray-900 mb-2">
                      R$ 97,00
                    </p>
                    <p className="text-lg font-semibold text-gray-800">
                      ou <span className="text-green-700">12x de R$ 10,03</span>
                    </p>
                  </div>
                </>
                :
                <>
                  <div className="text-center md:text-left">
                    <p className="text-gray-800 text-sm font-semibold mb-1">DE R$ 400,00 POR:</p>
                    <p className="text-4xl md:text-5xl font-black text-gray-900 mb-2">
                      R$ 249,90
                    </p>
                    <p className="text-lg font-semibold text-gray-800">
                      ou <span className="text-green-700">10x de R$ 24,99</span>
                    </p>
                    <p className="text-sm text-gray-700">(sem juros)</p>
                  </div>
                </>
              }

              <div className="text-center md:text-right">
                <button
                  onClick={() => {
                    if (typeCta) {
                      window.open(`https://pay.hotmart.com/R21755005K?off=pkaz1a9i`, "_self")
                    } else {
                      window.open('https://www.google.com/url?q=https%3A%2F%2Fpay.hotmart.com%2FR21755005K&sa=D&sntz=1&usg=AOvVaw3vKgK50XQmvUsuZUb4JTEU', "_self")
                    }
                  }
                  }
                  className="bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white font-bold text-lg px-8 py-4 rounded-lg shadow-xl transform hover:scale-105 transition-all duration-300 w-full md:w-auto"
                >
                  GARANTIR MINHA VAGA
                </button>
                <p className="text-xs text-gray-800 mt-2 font-medium">
                  🔒 Pagamento 100% seguro
                </p>
              </div>
            </div>

            <div className="bg-red-600 text-white rounded-lg px-4 py-3 text-center">
              <p className="text-base md:text-lg font-bold">
                ⚠️ OFERTA VÁLIDA SOMENTE HOJE
              </p>
            </div>
          </div>

          <div className="mt-6 grid grid-cols-3 gap-3 text-center">
            <div className="text-[#E18E37]">
              <div className="text-2xl mb-1">✅</div>
              <p className="text-xs text-gray-300 font-medium">Acesso Vitalício</p>
            </div>
            <div className="text-[#E18E37]">
              <div className="text-2xl mb-1">🎓</div>
              <p className="text-xs text-gray-300 font-medium">Certificado Incluso</p>
            </div>
            <div className="text-[#E18E37]">
              <div className="text-2xl mb-1">💯</div>
              <p className="text-xs text-gray-300 font-medium">Garantia 7 Dias</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PaymentCTA;
